import { createSlice } from '@reduxjs/toolkit'
import { earlierDate, currentDate } from '../../services/Util';
import Constants from "../../Constants";

var startDate = currentDate();
startDate = startDate.subtract(3, "months");
var endDate = currentDate();
var newDateRange = [startDate?._d,endDate._d]

export const CalendarRangeSlice = createSlice({
  name: 'calendar_range',
  initialState: {
    range : Constants.DEFAULT_DATE_RANGE
  },
  reducers: {
    setCalendarDateRange: (state, action) => {
      state.range = action.payload;
    },
  },
})

export const { setCalendarDateRange } = CalendarRangeSlice.actions

export default CalendarRangeSlice.reducer